var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStdio48Line = function SvgIconStdio48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 38.7H14.6a5.31 5.31 0 0 1-5.3-5.3V14.6c0-2.92 2.38-5.3 5.3-5.3h18.8c2.92 0 5.3 2.38 5.3 5.3v18.8c0 2.92-2.38 5.3-5.3 5.3Zm-18.8-26a1.9 1.9 0 0 0-1.9 1.9v18.8c0 1.05.85 1.9 1.9 1.9h18.8a1.9 1.9 0 0 0 1.9-1.9V14.6a1.9 1.9 0 0 0-1.9-1.9H14.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.11 31.29-2.21-2.58L20.4 24l-5.5-4.71 2.21-2.58 5.94 5.09c.64.55 1.01 1.35 1.01 2.2 0 .85-.37 1.65-1.01 2.2l-5.94 5.09ZM33 27.89h-8v3.4h8v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconStdio48Line;